import { render, staticRenderFns } from "./SpecialBiwako202310.vue?vue&type=template&id=683e5f7a&scoped=true"
import script from "./SpecialBiwako202310.vue?vue&type=script&lang=js"
export * from "./SpecialBiwako202310.vue?vue&type=script&lang=js"
import style0 from "./SpecialBiwako202310.vue?vue&type=style&index=0&id=683e5f7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683e5f7a",
  null
  
)

export default component.exports